import { useAuthStore } from "@/stores/auth";

/**
 * Returns the active organization id as a string, or null when the user is in
 * "All organizations" mode (activeOrganizationId === null in the store).
 *
 * Components and query hooks use this to add `?org_id=<id>` to API calls when
 * an org is selected, or omit it to get the merged multi-org view.
 */
export function useActiveOrgId(): string | null {
  return useAuthStore((s) => s.activeOrganizationId);
}
